import { RegentsExamsStepperCtrl } from './regents-exams-stepper.controller';

export const RegentsExamsStepperComponent = {
  controller: RegentsExamsStepperCtrl,
  bindings: {
    isLoading: '<',
    schoolSupports: '<',
    studentSupports: '<',
    currentSchool: '<',
  },
  template: require('./regents-exams-stepper.html'),
};
